import React, { Component } from 'react';
import NumberUtils from '../../utils/NumberUtils';
import moment from 'moment';
import PropTypes from 'prop-types';

const E_ELLIPSIS = 'e-ellipsis';

class TransactionRowTemplateMobile extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);

    this.state = {
      rowCustomClass: E_ELLIPSIS,
    };
  }

  onClick() {
    this.setState({
      rowCustomClass:
        this.state.rowCustomClass === E_ELLIPSIS ? 'row-open' : E_ELLIPSIS,
    });
  }

  render() {
    const { rowData } = this.props;
    const accountIndexCls = `account-${rowData.accIndex}`;

    return (
      <div onClick={this.onClick} className="transaction-screen-row">
        <h5>{moment(rowData.date).format('DD MMM YY')}</h5>
        <section>
          <h5 className={`${accountIndexCls} ${this.state.rowCustomClass}`}>
            {rowData.description}
          </h5>
          <p className={accountIndexCls}>
            {rowData.inProgress && <span className="icon icon-waiting" />}
            {rowData.account}
          </p>
        </section>
        <section>
          <h5>
            {NumberUtils.appendCurrency('{}', rowData.amount, rowData.currency)}
          </h5>
          <p>{rowData.type}</p>
        </section>
      </div>
    );
  }
}

TransactionRowTemplateMobile.propTypes = {
  rowData: PropTypes.object,
  metadata: PropTypes.object,
  customClick: PropTypes.func,
};

export { TransactionRowTemplateMobile };
